export default __webpack_public_path__ + "static/media/dropdown-down-arrow.be499b2d.svg";